import ReportCard from './ReportCard';
import { Box } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { remCalc } from '@monorepo/shared/src/util/style-util';

type Props = {
  reportData: any;
};

const ActivityReport: React.FC<Props> = (props) => {
  const classes = useStyles();
  const { reportData } = props;

  const computeRender = () => {
    return reportData.map((eachReport, idx) => {
      return <ReportCard key={idx} {...eachReport} />;
    });
  };
  return <Box className={classes.activityReportContainer}>{computeRender()}</Box>;
};

const useStyles = makeStyles(() => ({
  activityReportContainer: {
    width: '100%',
    display: 'grid',
    justifyContent: 'space-evenly',
    gridTemplateColumns: `repeat(auto-fit, ${remCalc(215)})`,
    gridGap: remCalc(18),
    padding: `${remCalc(20)} 0`,
  },
}));

export default ActivityReport;
